//@ts-nocheck
import { LitElement, html, css } from 'lit'
import globalStyles from '../../../../shared/global-styles.js'
import './wallet-list.js'
import { WalletCardEvents } from '../../shared/wallet-card/wallet-card.js'
import '../../../utilities/app-events.js'
import AppEvents from '../../../utilities/app-events.js'
import MovingBlocksLoaderElement from '../../shared/moving-blocks-loader/moving-blocks-loader.js'

export const WalletDropdownEvents = {
  SELECTED_WALLET: 'selected-wallet',
  OPEN_WALLET: 'open-wallet',
}

class SelectWalletHeaderDropdownElement extends LitElement {
  static properties = {
    selectedAccount: { type: Object },
    wallets: { type: Array },
    isLogin: { type: Boolean },
    opened: { type: Boolean, reflect: true },
    hasToolbar: { type: Boolean },
    refreshing: { type: Boolean },
  }

  constructor() {
    super()
    this.wallets = null
    this.selectedAccount = null
    this.opened = false
    this.refreshing = false
    this.hasToolbar = false
    this.addEventListener('selected-account', this.handleSelectedAccount)
  }

  connectedCallback() {
    super.connectedCallback()
    window.Globals.onUpdate(
      (/** @type {CustomEvent} */ { detail: { selectedAccount, wallets } }) => {
        this.selectedAccount = selectedAccount
        this.wallets = wallets
      }
    )
    window.addEventListener('open-wallet', this.handleOpenWallet.bind(this))
    this.addEventListener(
      WalletCardEvents.SELECTED_WALLET,
      this.handleSelectedAccount
    )

    window.addEventListener('wallet-connect', () => {
      window.Globals.checkWallets()
    })
  }

  removeToolbar(/** @type {CustomEvent} */ event) {
    this.hasToolbar = event.detail.hasToolbar
  }

  handleSelectedAccount(/** @type {CustomEvent} */ event) {
    this.selectedAccount = event.detail

    window.Globals.update({
      selectedAccount: this.selectedAccount,
    })

    window.dispatchEvent(
      new CustomEvent('selected-account', {
        detail: this.selectedAccount,
        bubbles: true,
        composed: true,
      })
    )

    this.requestUpdate('selectedAccount')
  }

  handleOpenWallet(/** @type {CustomEvent} */ event) {
    this.opened = event.detail.opened
  }

  handleBackgroundClick() {
    window.dispatchEvent(new CustomEvent('selected-account'))
    window.dispatchEvent(
      new CustomEvent('open-wallet', {
        detail: { opened: false },
        bubbles: true,
        composed: true,
      })
    )
  }

  refresh() {
    this.refreshing = true
    setTimeout(() => {
      window.Globals.checkWallets()
      this.refreshing = false
      window.location.reload()
    }, 500)
  }

  render() {
    const hasDao = this.wallets?.length > 0

    return html`
      <div
        ?hastoolbar=${this.hasToolbar}
        class="drop-down ${this.opened ? '' : 'drop'} "
      >
        ${hasDao
          ? html`
              <wallet-list
                style="margin-top: 16px;"
                .selectedAccount=${this.selectedAccount}
                .wallets=${this.wallets}
              >
              </wallet-list>
            `
          : html`
              <div style="margin-top: 16px;">
                <p>No DAOs found</p>
              </div>
              ${this.refreshing
                ? html`<moving-blocks-loader></moving-blocks-loader>`
                : html`<button class="refresh-button" @click=${this.refresh}>
                    Refresh Wallets
                  </button>`}
            `}
      </div>
      <div
        class="${this.opened ? 'clickBackground' : ''}"
        @click="${this.handleBackgroundClick}"
      ></div>
    `
  }

  static styles = css`
    ${globalStyles}

    .drop-down {
      position: relative;
      z-index: 2;
      top: 0;
      left: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: auto;
      height: auto;
      max-height: 75vh;
      overflow: scroll;
      padding: 0 24px;
      border-radius: 0px 0px 8px 8px;
      border: 2px solid var(--LightGrey, #b9b9b9);
      background: var(--White, #f7f7f7);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      transition: top 0.3s ease;
    }
    [hastoolbar] {
      top: var(--header-toolbar-height);
    }
    .drop {
      top: -250px;
      height: 0px;
    }
    .clickBackground {
      display: block;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 40px;
      left: 0;
      pointer-events: auto;
      z-index: 0;
      background: linear-gradient(
        180deg,
        rgba(66, 66, 66, 0.33) 0%,
        rgba(49, 49, 49, 0.74) 100%
      );
    }
    .refresh-button {
      padding: 10px;
      border-radius: 8px;
      background: var(--Color, #fff);
      border: 2px solid var(--white-2);
      margin-bottom: 16px;
      color: var(--kula-grey-1);
      font-size: 12px;
    }
  `
}

customElements.define(
  'select-wallet-header-dropdown',
  SelectWalletHeaderDropdownElement
)
export default SelectWalletHeaderDropdownElement
